import React, { FC } from 'react';
import { iconSize } from '../../../../constants/icon.constants';
import Icon from '../../icon';
import { TEELink } from '../types/socialMediaBar.types';
import fields, { socialMediaBarFields } from '../../../../constants/fields.const';
import { EditFrameComponent } from '../../editFrame';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';

const EELink: FC<TEELink> = (props) => {
  const { item } = props;
  const {sitecoreContext} = useSitecoreContext();
  return (
    <>
      <EditFrameComponent
        itemId={item?.id}
        fields={[fields.icon, socialMediaBarFields.socialMedia, socialMediaBarFields.postText]}
        sitecoreContext={sitecoreContext}
      >
        <Icon iconField={item?.fields?.icon} size={iconSize.mbl} color={'primary'} extraClassName={'social-media-bar__social-icon-EE'} />
      </EditFrameComponent>
    </>
  );
};

export default EELink;
